module.exports = __webpack_public_path__ + "img/download_button.31c4db6b.svg";